import { createBrowserHistory } from 'history';

export default createBrowserHistory({ basename: '/newflow' });



// WEBPACK FOOTER //
// ./src/routes/history.js